import type { Request } from '../../../index'

import {
  WarehouseTabInfo,
  isWarehouseTab,
  WarehouseTab,
  WarehouseTabs,
} from 'app/common/types/warehouse/tabs'

type ResultDto = Array<{
  key: string
  title: string
  active: boolean
  stub: boolean
}>

export const convertResult = (data: ResultDto): WarehouseTabs => {
  return new Map(
    data.reduce(
      (acc, { key, title, active, stub }) => {
        if (isWarehouseTab(key)) {
          acc.push([
            key as WarehouseTab,
            { key: key as WarehouseTab, title, isActive: !!active, isStub: !!stub },
          ])
        }
        return acc
      },
      [] as Array<[WarehouseTab, WarehouseTabInfo]>,
    ),
  )
}

export const GET_WAREHOUSE_TABS: Request<void, WarehouseTabs, void> = [
  'food/warehouse/tabs',
  'get',
  ['data', 'tabs'],
]
